import { makeStyles } from 'tss-react/mui';

export const useNoDataContainerStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
}));
